/**
 * Canvas pool
 * Helps with memory management
 */
class CanvasPool
{
    private pool: HTMLCanvasElement[];

    constructor()
    {
        this.pool = [];
    }

    /**
     * Preallocates pool with a specific amount of canvas's
     * @param amount
     */
    public preAllocate(amount: number)
    {
        for (let i = 0; i < amount; i++)
        {
            this.pool.push(document.createElement('canvas'));
        }
    }

    /**
     * Returns a canvas element
     */
    public get(): HTMLCanvasElement
    {
        let canvas: HTMLCanvasElement;

        if (this.pool.length > 0)
        {
            canvas = this.pool.pop();
        }
        else
        {
            canvas = document.createElement('canvas');
        }

        return canvas;
    }

    /**
     * Frees and adds a canvas element to the pool
     * @param canvas
     */
    public free( canvas: HTMLCanvasElement )
    {
        this.pool.push(canvas);
    }
}

export default new CanvasPool();